import TieupImg from "src/components/common/TieupImg"
import Link from "next/link"
import { SizeType } from "../../../common/TieupImg/SizeType"

type Props = {
  title?: string
  catchCopy?: string
  thumbnailUrl?: string
  link: string
}

const WorkCard: React.FC<Props> = ({
  title = "",
  catchCopy = "",
  thumbnailUrl = "/img/cover.png",
  link = "",
}) => {
  return (
    <>
      <article className="creatorIndex-workCard">
        <div className="creatorIndex-workCard-image">
          <Link href={link}>
            <a className="creatorIndex-workCard-image-anchor">
              <TieupImg src={thumbnailUrl} alt={title} size={SizeType.s} />
            </a>
          </Link>
        </div>
        <div className="creatorIndex-workCard-detail">
          <h3 className="creatorIndex-workCard-title">
            <Link href={link}>
              <a className="creatorIndex-workCard-anchor">{title}</a>
            </Link>
          </h3>
          <p className="creatorIndex-workCard-copy">{catchCopy}</p>
        </div>
      </article>
    </>
  )
}

export default WorkCard
